export default __webpack_public_path__ + "static/media/bpt-uguraw.c17f04d7.png";